export const isNotNil = <T>(data: T | null | undefined): data is T => !isNil(data);
export const isNil = <T>(data: T | null | undefined): data is null | undefined => data === undefined || data === null;

export function isNotEmpty(data: string | null | undefined): data is string {
	return isNotNil(data) && data.trim().length > 0;
}
